"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArcProxyFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var ArcProxyFactory = /** @class */ (function (_super) {
    __extends(ArcProxyFactory, _super);
    function ArcProxyFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    ArcProxyFactory.prototype.deploy = function (_logic, admin_, _data, overrides) {
        return _super.prototype.deploy.call(this, _logic, admin_, _data, overrides || {});
    };
    ArcProxyFactory.prototype.getDeployTransaction = function (_logic, admin_, _data, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _logic, admin_, _data, overrides || {});
    };
    ArcProxyFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    ArcProxyFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    ArcProxyFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return ArcProxyFactory;
}(contracts_1.ContractFactory));
exports.ArcProxyFactory = ArcProxyFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_logic",
                type: "address",
            },
            {
                internalType: "address",
                name: "admin_",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        stateMutability: "payable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        stateMutability: "payable",
        type: "fallback",
    },
    {
        inputs: [],
        name: "admin",
        outputs: [
            {
                internalType: "address",
                name: "admin_",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "changeAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "implementation_",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
var _bytecode = "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";
